"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArcProxyFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var ArcProxyFactory = /** @class */ (function (_super) {
    __extends(ArcProxyFactory, _super);
    function ArcProxyFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    ArcProxyFactory.prototype.deploy = function (_logic, admin_, _data, overrides) {
        return _super.prototype.deploy.call(this, _logic, admin_, _data, overrides || {});
    };
    ArcProxyFactory.prototype.getDeployTransaction = function (_logic, admin_, _data, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _logic, admin_, _data, overrides || {});
    };
    ArcProxyFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    ArcProxyFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    ArcProxyFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return ArcProxyFactory;
}(contracts_1.ContractFactory));
exports.ArcProxyFactory = ArcProxyFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_logic",
                type: "address",
            },
            {
                internalType: "address",
                name: "admin_",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        stateMutability: "payable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        stateMutability: "payable",
        type: "fallback",
    },
    {
        inputs: [],
        name: "admin",
        outputs: [
            {
                internalType: "address",
                name: "admin_",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "changeAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "implementation_",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
var _bytecode = "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";
